// extracted by mini-css-extract-plugin
export default {"exampleBox":"cHcvU0R1hVglS6FjMS74","trigger":"ZwX777nzSu0KO5XZudbB"};